export default "__VITE_ASSET__28e4e5f8__"